/* eslint-disable */

function generateUniqueId() {
  let uniqueId = '';
  // our webpack only targets recent browsers, so we fall back from `crypto.randomUUID` to `Math.random`
  // to ensure old browser requests can still be traced
  if (typeof window.crypto?.randomUUID === 'function') {
    uniqueId = `${Date.now()}${window.crypto.randomUUID()}`;
  } else {
    uniqueId = `${Date.now()}${Math.random().toString(16)}`;
    uniqueId = uniqueId.replace('.', '');
  }
  return uniqueId;
}

const nextivaOrLocalRegex = /nextos.com|nextiva.xyz|localhost/;
const httpRegex = /^http:|^https:/;
function shouldSkipRequestIdHeaderGeneration(url = '') {
  const isAbsoluteUrl = httpRegex.test(url.toString());
  // if its an absolute URL, check to see if the host is a nextiva domain. We know that all relative URLs are targeting nextiva
  const isTargetingNextivaDomain = isAbsoluteUrl
    ? nextivaOrLocalRegex.test(new URL(url).hostname)
    : true;
  // other providers (Datadog, Pendo, etc) will throw CORS errors if we send a request with a header they dont recognize
  // so we skip adding the header on any absolute urls that dont point to Nextiva
  return isAbsoluteUrl && !isTargetingNextivaDomain;
}

const { fetch: originalFetch } = window;
window.fetch = async (resource, config = {}) => {
  if (shouldSkipRequestIdHeaderGeneration(resource)) {
    return originalFetch(resource, config);
  }

  if (!config.headers) {
    config.headers = new Headers();
  }
  /* 
        Im not 100% sure this `if/else` block is needed (could probably be shortened/simplified)
        but due to difficulty testing this after deploying this to `dev`, this seemed to be the safest approach.
      */
  if (config.headers instanceof Headers) {
    config.headers.append('nextiva-context-requestId', generateUniqueId());
  } else {
    config.headers['nextiva-context-requestId'] = generateUniqueId();
  }
  return originalFetch(resource, config);
};

const origXhrOpen = window.XMLHttpRequest.prototype.open;
window.XMLHttpRequest.prototype.open = function (...args) {
  const targetUrl = args[1];
  if (shouldSkipRequestIdHeaderGeneration(targetUrl)) {
    this.skipRequestId = true;
  }

  return origXhrOpen.apply(this, args);
};

const origXhrSend = window.XMLHttpRequest.prototype.send;
window.XMLHttpRequest.prototype.send = function (...args) {
  if (this.skipRequestId) {
    return origXhrSend.apply(this, args);
  }

  let uid = generateUniqueId();
  /*
        we need a way to see the requestId within the Datadog `context` so that we 
        can send it to RUM in the `DD_RUM.init.beforeSend`. The `context` doesnt have
        the headers on the XHR during beforeSend, but it does have the XHR object itself. 
        So we add the requestId to the XHR object, read it, and send to RUM.
      */
  this.nextivaContextRequestId = uid;
  this.setRequestHeader('nextiva-context-requestId', uid);
  return origXhrSend.apply(this, args);
};

function startDataDog() {
  (function (h, o, u, n, d) {
    h = h[d] = h[d] || {
      q: [],
      onReady: function (c) {
        h.q.push(c);
      },
    };
    d = o.createElement(u);
    d.async = 1;
    d.src = n;
    n = o.getElementsByTagName(u)[0];
    n.parentNode.insertBefore(d, n);
  })(
    window,
    document,
    'script',
    'https://www.datadoghq-browser-agent.com/datadog-rum.js',
    'DD_RUM',
  );
  DD_RUM.onReady(function () {
    DD_RUM.init({
      clientToken: 'pubcf1f982f994c10171e17620c21f653fc',
      applicationId: '9c85cbc0-9915-4887-bd1e-c18c65e2aaa1',
      env: window.NextivaEnv,
      sampleRate: 100,
      trackInteractions: true,
      // this injects the `package.json` version via HtmlWebpackPlugin
      // which allows us to tie errors in DataDog RUM to the version of the deployed app
      version: '<%= packageJsonVersion %>',
      beforeSend: (event, context) => {
        // collect the requestId if its available. Currently this only works for XHR requests,
        // (which is 100% of our API calls, thanks to axios). Fetch support would need to be added later, if its needed
        if (
          event.type === 'resource' &&
          event.resource &&
          (event.resource.type === 'xhr' || event.resource.type === 'fetch')
        ) {
          if (context.xhr && context.xhr.nextivaContextRequestId) {
            event.context = {
              ...event.context,
              requestId: context.xhr.nextivaContextRequestId,
            };
          }
        }
      },
    });
  });
}

export { startDataDog };
